import { useCallback } from 'react';
import {
	trackInitiateCheckoutOnPixel,
	trackOnPixel
} from '../FbPixel/pixelEvents';

export const CURSEDUCA_PIXEL_ID = '837834646732115';

/**
 * Pixel da Curseduca no auto-checkout. `trackSingle` (ver `pixelEvents.ts`):
 * o pixel da plataforma e o do builder também podem estar na página.
 * InitiateCheckout sai uma vez por pixel — se a plataforma usar este mesmo
 * pixel, ele não recebe dois.
 */
export const useCurseducaPixel = (enabled: boolean) => {
	const track = useCallback(
		(event: string, data?: unknown) => {
			if (!enabled) return;

			if (event === 'InitiateCheckout') {
				trackInitiateCheckoutOnPixel(CURSEDUCA_PIXEL_ID, data);
				return;
			}
			trackOnPixel(CURSEDUCA_PIXEL_ID, event, data);
		},
		[enabled]
	);

	return { track };
};
